/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mascot_TaglineInputs */

const en_mascot_tagline = /** @type {(inputs: Mascot_TaglineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Small steps, together.`)
};

const id_mascot_tagline = /** @type {(inputs: Mascot_TaglineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Langkah kecil, bareng-bareng.`)
};

/**
* | output |
* | --- |
* | "Small steps, together." |
*
* @param {Mascot_TaglineInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mascot_tagline = /** @type {((inputs?: Mascot_TaglineInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mascot_TaglineInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mascot_tagline(inputs)
	return en_mascot_tagline(inputs)
});